export default class RadioGroupController {
  constructor($scope) {
    'ngInject'
    this._$scope = $scope
  }

  $onInit() {
    this.ngModelCtrl.$render = () =>
      this.ngModelCtrl.$setViewValue(this.ngModelCtrl.$viewValue)

    this._$scope.$watch(
      () => this.ngModelCtrl.$viewValue,
      () => {
        this.ngModelCtrl.$render()
      }
    )
  }
}
